var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoTimeOutLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_09-timer",
    "data-name": "09-timer",
    transform: "translate(-8)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48544",
    "data-name": "Path 48544",
    d: "M25.27,7.141,26.707,5.7,25.293,4.291,23.756,5.827A9.939,9.939,0,0,0,19,4.048V2h2V0H15V2h2V4.048a9.939,9.939,0,0,0-4.756,1.779L10.707,4.291,9.293,5.7,10.73,7.141a10,10,0,1,0,14.54,0ZM18,21.99a8,8,0,1,1,8-8A8,8,0,0,1,18,21.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48545",
    "data-name": "Path 48545",
    d: "M30,32v6H24a6,6,0,1,0,6-6Z",
    transform: "translate(-12 -24.004)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoTimeOutLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_time_out_limit.d6cd04df9bbad8d9d6575271e395ac58.svg";